import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'
import { useSurveysIdContext } from 'pages/surveys/context/surveysIdContext'
import { SurveyView } from 'pages/surveys/ui/SurveyView/SurveyView'

export const EditSurvey = () => {
  const { pageLayoutStore } = useSurveysPageContext()
  const response = useSurveysIdContext()

  return <SurveyView pageLayoutStore={pageLayoutStore} response={response} />
}
